/**
 * Permission codes the customer liability screens declare an interest in
 * (`server/internal/liability/permissions.go`, FIN-FR-024).
 *
 * `finance.liability.manage` decides whether lapsed balances become income, so it is held apart
 * from the read. A holder of manage edits and saves, nobody else sees the tab. The server holds a
 * change that starts or redirects income for a second person's approval (approvals doc type
 * `finance.liability_settings`, `settings.go` UpdateSettings); switching to "none" applies at once.
 */

export const LIABILITY_PERMISSIONS = {
  /** The register, the breakage report and the breakage policy read. */
  read: 'finance.liability.read',
  /** State the breakage policy and the income account breakage is credited to. */
  manage: 'finance.liability.manage',

  /** Postable accounts for the breakage income account picker. */
  accountRead: 'org.account.read',
  /** Open an on-account AR receipt (the only source with a page of its own). */
  receiptRead: 'ar.receipt.read',
} as const

export type LiabilityPermission = (typeof LIABILITY_PERMISSIONS)[keyof typeof LIABILITY_PERMISSIONS]
